export default __webpack_public_path__ + "static/terms-b314041a5efe221ad83797ee95eabb83.jpg";